/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export class ClusterManagerService {
  constructor($http, $rootScope, baseUrlSrv) {
    'ngInject';

    this.$http = $http;
    this.$rootScope = $rootScope;
    this.BaseUrlService = baseUrlSrv;
  }

  setCurrentCluster(clusterName) {
    const url = this.BaseUrlService.getRestApiBase() + '/magpie/clusters/current';
    return this.$http({method: 'POST', url: url, data: {clusterName: clusterName}});
  }

  getClusters() {
    const url = this.BaseUrlService.getRestApiBase() + '/magpie/clusters';
    return this.$http({method: 'GET', url: url});
  }
}



// WEBPACK FOOTER //
// ./src/app/clusters/cluster-manager.service.js